import { useEffect, useRef, useState } from 'react';

const SCRAMBLE_CHARS = '!<>-_\\/[]{}—=+*^?#0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

// Decrypt-style text scramble: cycles through random glyphs before resolving
// left-to-right into the final text. Used for the mobile nav menu's
// "digital" reveal effect. Re-runs automatically whenever the component
// mounts (i.e. every time the menu opens, since Radix unmounts on close).
export const TextScramble = ({ text, className = '', delay = 0, speed = 28 }) => {
  const [display, setDisplay] = useState(text);
  const frameRef = useRef(0);
  const timeoutRef = useRef(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    const chars = text.split('');
    const totalFrames = chars.length + 8;
    frameRef.current = 0;
    setDisplay(chars.map((ch) => (ch === ' ' ? ' ' : SCRAMBLE_CHARS[0])).join(''));

    const tick = () => {
      const frame = frameRef.current;
      const resolvedCount = Math.max(0, frame - 6);
      const next = chars
        .map((ch, i) => {
          if (ch === ' ') return ' ';
          if (i < resolvedCount) return ch;
          return SCRAMBLE_CHARS[Math.floor(Math.random() * SCRAMBLE_CHARS.length)];
        })
        .join('');
      setDisplay(next);
      frameRef.current += 1;
      if (frameRef.current > totalFrames) {
        setDisplay(text);
        clearInterval(intervalRef.current);
      }
    };

    timeoutRef.current = setTimeout(() => {
      intervalRef.current = setInterval(tick, speed);
    }, delay);

    return () => {
      clearTimeout(timeoutRef.current);
      clearInterval(intervalRef.current);
    };
  }, [text, delay, speed]);

  return <span className={className}>{display}</span>;
};
